import React from "react"
import { type ChakraProps, Heading, useColorMode } from "@chakra-ui/react"
import { Colors } from "../../theme/colors"

interface Heading2CapsPropsInterface {
  text: string
  props?: ChakraProps
}
export const RHeading3PT = ({ text, props }: Heading2CapsPropsInterface): JSX.Element => {
  const { colorMode } = useColorMode()

  return (
    <Heading
      color={colorMode === "light" ? Colors.Secondary.c2 : "white"}
      variant={"RHeading3PT"}
      borderBottomWidth="2px"
      borderBottomColor={Colors.Primary.accent}
      textAlign={"left"}
      p="10px"
      py="10px"
      maxW={["280px", "280px", "100%"]}
      display={"inline-block"}
      {...props}
    >
      {text}
    </Heading>
  )
}
